function InitializePromotionModals() {
  var modal = new Foundation.Reveal($('.promotion-modal'));
  modal.open();
}

(function () {
  $('.promotion-top a.button').removeAttr('class');
})();